import React from 'react';

import { useTranslation } from 'react-i18next';

import { PromotionPrizeType } from '@shared/types';

import * as Styled from './prize-card.styled';

type OwnProps = {
	prize: PromotionPrizeType;
};

const PrizeCard: React.FC<OwnProps> = ({ prize }) => {
	const { t } = useTranslation('main');

	return (
		<Styled.Wrapper $bg={prize.image}>
			<Styled.PrizePlace>{`${prize.position} ${t('place')}`}</Styled.PrizePlace>
			<Styled.PrizeType>{prize.description}</Styled.PrizeType>
			<Styled.PrizeName>{prize.name}</Styled.PrizeName>
		</Styled.Wrapper>
	);
};

export default PrizeCard;
